"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var InputRadio = /*#__PURE__*/function (_React$Component) {
  _inherits(InputRadio, _React$Component);

  function InputRadio(props) {
    _classCallCheck(this, InputRadio);

    return _possibleConstructorReturn(this, (InputRadio.__proto__ || Object.getPrototypeOf(InputRadio)).call(this, props));
  }

  _createClass(InputRadio, [{
    key: "render",
    value: function render() {
      var radioClasses = 'radio';

      if (this.props.disabled) {
        radioClasses += ' ' + 'disabled';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: radioClasses
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        name: this.props.name,
        value: this.props.value,
        id: this.props.id,
        checked: this.props.checked ? 'checked' : '',
        disabled: this.props.disabled ? 'disabled' : '',
        onChange: this.props.click
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: this.props.id
      }, this.props.label));
    }
  }]);

  return InputRadio;
}(_react.default.Component);

InputRadio.propTypes = {
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  click: _propTypes.default.func.isRequired,
  id: _propTypes.default.any,
  label: _propTypes.default.string.isRequired,
  name: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired
};
InputRadio.defaultProps = {
  disabled: false
};
var _default = InputRadio;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/input-radio.js
// module id = 229
// module chunks = 0